import { notProduction } from '../constants/notProduction';

export const getTracesSampleRate = (): number => {
  const AUTOMATION_TRACES_SAMPLE_RATE = 0.1;
  const NON_PRODUCTION_TRACES_SAMPLE_RATE = 1.0;
  const PRODUCTION_TRACES_SAMPLE_RATE = 0.25;

  // user agent is controlled by automation
  if (navigator.webdriver) {
    return AUTOMATION_TRACES_SAMPLE_RATE;
  }

  if (notProduction) {
    return NON_PRODUCTION_TRACES_SAMPLE_RATE;
  }

  return PRODUCTION_TRACES_SAMPLE_RATE;
};
